import { LecturerDTO } from "@onetutor/shared/user";

export function getLecturerDisplayName(
  lecturer: LecturerDTO | undefined,
): string {
  if (
    lecturer === undefined ||
    (lecturer.lastName === "" && lecturer.firstName === "")
  ) {
    return "";
  }
  return `${lecturer.title ?? ""} ${lecturer.firstName} ${lecturer.lastName}`;
}
